import React from 'react';
import { Link } from 'react-router-dom';

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-background text-foreground px-4 py-10">
      <div className="max-w-3xl mx-auto flex flex-col gap-6">
        <div>
          <Link to="/register" className="text-sm text-primary hover:underline">&larr; Back to registration</Link>
        </div>
        <h1 className="text-2xl font-bold">Privacy Policy</h1>
        <p className="text-xs text-muted-foreground">Last updated: April 2026</p>

        <section className="flex flex-col gap-2">
          <h2 className="text-base font-semibold">1. Data We Collect</h2>
          <p className="text-sm text-muted-foreground">
            We collect the information you provide when you register: your name, email
            address, and hashed password. We also store configuration data you create
            within the platform (screeners, strategies, trading setups) and the date you
            accepted these terms.
          </p>
        </section>

        <section className="flex flex-col gap-2">
          <h2 className="text-base font-semibold">2. How We Use Your Data</h2>
          <p className="text-sm text-muted-foreground">
            Your data is used solely to operate the platform — to authenticate you,
            associate your screeners and strategies with your account, and provide the
            service. We do not use your data for advertising or profiling.
          </p>
        </section>

        <section className="flex flex-col gap-2">
          <h2 className="text-base font-semibold">3. Data Sharing</h2>
          <p className="text-sm text-muted-foreground">
            We do not sell, rent, or share your personal data with third parties, except
            as required by law or to operate the platform (e.g., connecting to broker
            APIs you explicitly authorise). Broker credentials you provide are stored
            encrypted and are only used to execute actions you initiate.
          </p>
        </section>

        <section className="flex flex-col gap-2">
          <h2 className="text-base font-semibold">4. Data Security</h2>
          <p className="text-sm text-muted-foreground">
            Passwords are stored as bcrypt hashes and are never stored in plaintext.
            Authentication uses short-lived JWT tokens. Access to the database is
            restricted to the application server. We take reasonable measures to protect
            your data but cannot guarantee absolute security.
          </p>
        </section>

        <section className="flex flex-col gap-2">
          <h2 className="text-base font-semibold">5. Data Retention</h2>
          <p className="text-sm text-muted-foreground">
            Your data is retained for as long as your account exists. If you wish to
            delete your account and all associated data, contact the platform operator.
          </p>
        </section>

        <section className="flex flex-col gap-2">
          <h2 className="text-base font-semibold">6. Contact</h2>
          <p className="text-sm text-muted-foreground">
            For any privacy-related queries, contact the platform operator directly.
          </p>
        </section>

        <p className="text-xs text-muted-foreground mt-4">
          See also: <Link to="/terms" className="text-primary hover:underline">Terms of Use</Link>
        </p>
      </div>
    </div>
  );
}
